import React from 'react';
import SectionHeader from '../../../components/SectionHeader';
import ServiceCard from './ServiceCard';
import './ServicesSection.css';

interface Service {
  icon: string;
  title: string;
  description: string;
  features: string[];
  featured?: boolean;
  featuredBadge?: string;
}

interface ServicesSectionProps {
  services: Service[];
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ services }) => {
  return (
    <section id="services" className="services-section">
      <div className="container">
        <SectionHeader
          title="Our Services"
          subtitle="AI and data capabilities built for Retail and CPG Teams"
        />
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;

